import { FooterErrorItem } from '@/forms-legacy'

export const getErrorFieldHeader = (text: string): FooterErrorItem => {
  return { text, bold: true, groupHeader: true }
}

export const getErrorField = (text: string, indent?: boolean): FooterErrorItem => {
  return { text, indentLevel: indent ? 5 : 0 }
}
